import type { Tier } from '../../../../types'

export enum FormFields {
  annualDiscount = 'annualDiscount',
  title = 'title',
  description = 'description',
  price = 'price',
  discount = 'discount',
  discountType = 'discountType',
  monthDiscount = 'monthDiscount',
  yearDiscount = 'yearDiscount',
  timeLimit = 'timeLimit',
  startDate = 'startDate',
  endDate = 'endDate',
  image = 'image',
  imageFile = 'imageFile',
  removeImage = 'removeImage',
  convertInternationalPricing = 'convertInternationalPricing',
  currencies = 'currencies',
  askForShippingAddress = 'askForShippingAddress',
}

export type FormValues = {
  [FormFields.annualDiscount]?: number
  [FormFields.title]: string
  [FormFields.description]: string
  [FormFields.price]: string
  [FormFields.discount]?: boolean
  [FormFields.discountType]?: 'trial' | 'oneTime'
  [FormFields.monthDiscount]?: string
  [FormFields.yearDiscount]?: string
  [FormFields.timeLimit]?: boolean
  [FormFields.startDate]?: Date
  [FormFields.endDate]?: Date
  [FormFields.image]?: string
  [FormFields.imageFile]?: File
  [FormFields.removeImage]: boolean
  [FormFields.convertInternationalPricing]: boolean
  [FormFields.currencies]: Record<keyof Tier['variants']['monthly']['amounts'], string>
  [FormFields.askForShippingAddress]: boolean
}
